// src/pages/_app.js
import '../styles/globals.css';

import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { ProjectProvider } from '../context/ProjectContext';
import { UValueProvider } from '../context/UValueContext';
import { LibraryProvider } from '../context/LibraryContext';
import { EnergyProvider } from '../context/EnergyContext';
import { useEffect } from 'react';
import { setupStorage } from '../utils/idbKV';

import LoadingOverlay from '../components/LoadingOverlay';
const systemFontStack =
    'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

// create a basic theme—tweak palette/typography as you like
const theme = createTheme({
    typography: {           
        fontFamily: systemFontStack,
    },
    palette: {
        primary: { main: '#0070f3' },
        secondary: { main: '#555' },
    },
    components: {
        MuiButton: {
            defaultProps: { disableElevation: true },
        },
    }
});

export default function MyApp({ Component, pageProps }) {
    useEffect(() => { setupStorage(); }, []);
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <ProjectProvider>
                <UValueProvider>
                    <LibraryProvider>
                        <EnergyProvider>
                            {/* global “switching project” animation */}
                            <LoadingOverlay />
                            <Component {...pageProps} />
                        </EnergyProvider>
                    </LibraryProvider>
                </UValueProvider>
            </ProjectProvider>
        </ThemeProvider>
    );
}
